<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/commodityFlowAdjustmentList' }">流向调整</el-breadcrumb-item>
                <el-breadcrumb-item>流向调整{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params'] || {}"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <!-- 日期 -->
                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'search_select'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vSearchSelect
                                        :model_key="item.prop"
                                        :model_name="'请输入' + fieldTypeMap[item.prop]['title'] + '搜索'"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :default_option_key="fieldTypeMap[item.prop]['default_option_key']"
                                        :default_option="formData[fieldTypeMap[item.prop]['default_option_key']]"
                                        @onDropChange="onDropChange"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vSearchSelect>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'checkbox'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-checkbox v-model="formData[item.prop]" style="width: 280px"></el-checkbox>
                                </el-form-item>
                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, processColDataToEdit, checkNumber } from '@/js/common.js';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    name: 'commodityFlowAdjustmentEdit',
    components: {
        vSearchSelect
    },
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormData();
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.data.allotment_type_code = 1;
        }
    },
    methods: {
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                date: {
                    title: '日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'date_ref',
                    type: 'date'
                },
                start_date: {
                    title: '开始日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'start_date_ref',
                    type: 'date'
                },
                end_date: {
                    title: '结束日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'end_date_ref',
                    type: 'date'
                },
                representative_rid: {
                    request_uri: 'dropdownPartners',
                    title: '代表',
                    ref: 'representative_rid_ref',
                    type: 'dropdown'
                },
                partner_rid: {
                    request_uri: 'dropdownPartners',
                    title: '合作方',
                    ref: 'partner_rid_ref',
                    type: 'dropdown'
                },
                business_rid: {
                    request_uri: 'searchAccounts',
                    title: '一级商业',
                    ref: 'business_rid_ref',
                    default_option_key: 'business_option',
                    type: 'search_select'
                },
                product_rid: {
                    request_uri: 'dropdownProducts',
                    title: '产品',
                    ref: 'product_rid_ref',
                    type: 'dropdown',
                    request_params: { type_code: [11, 15, 91] }
                },
                performance_unit_code: {
                    request_uri: 'dropdownPerformanceUnit',
                    title: '绩效单元',
                    ref: 'performance_unit_code_ref',
                    type: 'dropdown',
                    request_params: { is_leaf: true },
                    select_value: 'code',
                    tips: '非叶子节点或23年以前的绩效单元，无法显示'
                },
                type_code: {
                    request_uri: 'dropdownReceivableAdjustmentType',
                    title: '类型',
                    ref: 'type_code_ref',
                    type: 'dropdown',
                    select_value: 'value'
                },
                allotment_type_code: {
                    request_uri: 'yesOrNo',
                    title: '关联源单分配',
                    ref: 'allotment_type_code_ref',
                    type: 'dropdown',
                    select_value: 'value'
                }
            };
        },
        initFormRule() {
            this.rules = {
                date: [{ required: true, message: '请输入调整单日期', trigger: 'blur' }],
                type_code: [{ required: true, message: '请选择类型', trigger: 'blur' }],
                allotment_type_code: [{ required: true, message: '请选择关联源单分配', trigger: 'blur' }],
                unit_expense_quota: [{ required: false, validator: checkNumber, trigger: 'blur' }],
                // 2026-09-28 放开：代表不再必填，改由合作方顶上（与后端 validation.php 对齐）
                partner_rid: [{ required: true, message: '请选择合作方', trigger: 'blur' }],
                expense_quota: [{ required: false, validator: checkNumber, trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                date: this.data.date || '',
                start_date: this.data.start_date || '',
                end_date: this.data.end_date || '',
                flow_rids: this.data.flow_rids || '',
                allotment_type_code: this.data.allotment_type_code || '1',
                representative_rid: this.data.representative_rid || '',
                partner_rid: this.data.partner_rid || '',
                business_rid: this.data.business_rid || '',
                product_rid: this.data.product_rid || '',
                performance_unit_code: this.data.performance_unit_code || '',
                expense_quota: this.data.expense_quota || '',
                unit_expense_quota: this.data.unit_expense_quota || '',
                type_code: this.data.type_code || '',
                remark: this.data.remark || '',
                business_option: {
                    rid: this.data.business_rid || '',
                    name: this.data.business ? this.data.business : ''
                }
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).commodity_flow_adjustment;
            processColDataToEdit(
                temp,
                this,
                {
                    white: ['date', 'start_date', 'end_date', 'flow_rids', 'expense_quota', 'unit_expense_quota', 'remark']
                },
                {
                    representative: 'representative_rid',
                    product: 'product_rid',
                    performance_unit_name: 'performance_unit_code',
                    type: 'type_code',
                    allotment_type_code_label: 'allotment_type_code',
                    partner: 'partner_rid',
                    business: 'business_rid',
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/commodityFlowAdjustmentList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .commodityFlowAdjustmentDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'commodityFlowAdjustmentUpdate';
            } else {
                uri = 'commodityFlowAdjustmentInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>